export const ADD_TO_COMPARE = 'ADD_TO_COMPARE';
export const REMOVE_PRODUCT_COMPARE = 'REMOVE_PRODUCT_COMPARE';
export const REMOVE_ALL_PRODUCTS_FROM_COMPARE = 'REMOVE_ALL_PRODUCTS_FROM_COMPARE';